import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

export const MessageRole = Schema.Literal("user", "assistant", "tool", "system");
export type MessageRole = Schema.Schema.Type<typeof MessageRole>;

export class Message extends Model.Class<Message>("Message")({
  id: Model.Generated(Schema.String),
  conversationId: Schema.String,
  role: MessageRole,
  content: Schema.Array(Schema.Unknown),
  messageIndex: Schema.Number,
  metadata: Schema.NullOr(Schema.Record({ key: Schema.String, value: Schema.Unknown })),
  createdAt: Model.DateTimeInsertFromDate,
}) {}
